import en from './en.json'
import it from './it.json'

export const publicLinkTranslations = {
	en,
	it
} as const
